document.addEventListener('DOMContentLoaded', function() {
    // radios button variations
    const radioButtons = document.querySelectorAll('input[name="attribute_tailles"]');
    const resetLink = document.querySelector('.reset_variations');
    
    radioButtons.forEach(radio => {
        radio.addEventListener('change', (e) => {
            radioButtons.forEach(radio => {
                radio.parentElement.classList.remove('selected');
            });

            const selectedRadio = Array.from(radioButtons).find(radio => radio.checked);
            
            if (selectedRadio) {
                selectedRadio.parentElement.classList.add('selected');
            }
        });
    });
    resetLink.addEventListener('click', (e) => {
        radioButtons.forEach(radio => {
            radio.parentElement.classList.remove('selected');
            radio.checked = false;
        });
    });
});
